import styled from 'styled-components';
import Button from '../../../../../../_shared/components/Button';

const negotiationButtonsStyling = `
  margin: 0;
  width: 100%;
`;

export const StyledSecondaryButton = styled(Button.Secondary)`
  padding: ${({ isSelling }) => (isSelling ? '8px' : '12px')};
  font-size: ${({ theme, isSelling }) =>
    isSelling ? theme.FONT_SIZES.SMALL : theme.FONT_SIZES.MEDIUM};
  ${negotiationButtonsStyling}
`;

export const StyledPrimaryButton = styled(Button.Primary)`
  padding: ${({ isSelling }) => (isSelling ? '8px' : '12px')};
  border-radius: ${({ isSelling }) => (isSelling ? '4px' : '5px')};
  font-size: ${({ theme, isSelling }) =>
    isSelling ? theme.FONT_SIZES.SMALL : theme.FONT_SIZES.MEDIUM};
  ${negotiationButtonsStyling}
`;

export const OmpSendToClosingButton = styled(Button.Secondary)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  width: 90%;
  margin-left: 12px;
`;
